module.exports = __webpack_public_path__ + "static/img/company_logo.1770538668457.png";